"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SP_TYPE_USER_MULTI = exports.SP_TYPE_USER = exports.SP_TYPE_URL = exports.SP_TYPE_TEXT = exports.SP_TYPE_NUMBER = exports.SP_TYPE_NOTE = exports.SP_TYPE_MULTI_CHOICE = exports.SP_TYPE_LOOKUP_MULTI = exports.SP_TYPE_LOOKUP = exports.SP_TYPE_INTEGER = exports.SP_TYPE_FULLHTML = exports.SP_TYPE_DATE_TIME = exports.SP_TYPE_CURRENCY = exports.SP_TYPE_COUNTER = exports.SP_TYPE_CHOICE = exports.SP_TYPE_CALCULATED = exports.SP_TYPE_BOOLEAN = exports.SP_TYPE_ATTACHMENTS = void 0;
// Type names that are used in SharePoint APIs and manifest list connection definitions
var SP_TYPE_ATTACHMENTS = exports.SP_TYPE_ATTACHMENTS = 'Attachments';
var SP_TYPE_BOOLEAN = exports.SP_TYPE_BOOLEAN = 'Boolean';
var SP_TYPE_CALCULATED = exports.SP_TYPE_CALCULATED = 'Calculated';
var SP_TYPE_CHOICE = exports.SP_TYPE_CHOICE = 'Choice';
var SP_TYPE_COUNTER = exports.SP_TYPE_COUNTER = 'Counter';
var SP_TYPE_CURRENCY = exports.SP_TYPE_CURRENCY = 'Currency';
var SP_TYPE_DATE_TIME = exports.SP_TYPE_DATE_TIME = 'DateTime';
var SP_TYPE_FULLHTML = exports.SP_TYPE_FULLHTML = 'FullHTML';
var SP_TYPE_INTEGER = exports.SP_TYPE_INTEGER = 'Integer';
var SP_TYPE_LOOKUP = exports.SP_TYPE_LOOKUP = 'Lookup';
var SP_TYPE_LOOKUP_MULTI = exports.SP_TYPE_LOOKUP_MULTI = 'LookupMulti';
var SP_TYPE_MULTI_CHOICE = exports.SP_TYPE_MULTI_CHOICE = 'MultiChoice';
var SP_TYPE_NOTE = exports.SP_TYPE_NOTE = 'Note';
var SP_TYPE_NUMBER = exports.SP_TYPE_NUMBER = 'Number';
var SP_TYPE_TEXT = exports.SP_TYPE_TEXT = 'Text';
var SP_TYPE_URL = exports.SP_TYPE_URL = 'URL';
var SP_TYPE_USER = exports.SP_TYPE_USER = 'User';
var SP_TYPE_USER_MULTI = exports.SP_TYPE_USER_MULTI = 'UserMulti';